var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 52,
    viewBox: "0 0 49 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconography",
    filter: "url(#filter0_d_3412_903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M44.3712 10.28V25.66C44.3829 27.5222 43.5725 29.2941 42.1577 30.5C41.0973 31.3814 39.766 31.8689 38.3888 31.88C38.0571 31.9098 37.7234 31.9098 37.3917 31.88L18.4473 28.46V7.50004L37.3917 4.14004C39.0939 3.84552 40.8388 4.32146 42.1577 5.44004C43.5659 6.65104 44.3747 8.41967 44.3712 10.28Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M14.459 8.19995V27.76L12.4648 27.4L10.4707 27.06L9.47362 26.88C8.36325 26.6981 7.3265 26.206 6.48239 25.46C5.18896 24.2354 4.46578 22.5237 4.48824 20.74V15.22C4.43645 12.2284 6.54217 9.63501 9.47362 9.07995L14.459 8.19995Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M16.4531 28.12V39C16.4531 41.7614 14.2211 44 11.4677 44C8.71438 44 6.48235 41.7614 6.48235 39V26C6.45185 25.8213 6.45185 25.6387 6.48235 25.46C7.30427 26.1927 8.31164 26.684 9.39381 26.88L10.3909 27.06L12.385 27.4L16.4531 28.12Z",
    fill: "#6B7CFF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3412_903",
    x: -3.5,
    y: 0,
    width: 55.8599,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3412_903"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3412_903",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/Icon5.5048a26fe335763645b0ad76fd086695.svg";
export { ForwardRef as ReactComponent };